var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"routeContainer"},[_c('v-breadcrumbs',{attrs:{"divider":"/","items":_vm.breadcrumbsItems}}),_c('RadioComponent',{attrs:{"header":_vm.header,"selected":1,"options":_vm.Languages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }